/** An account this new was made by the redirect that just finished. */
export const NEW_ACCOUNT_WINDOW_MS = 10 * 60 * 1000;

/** Where every new account goes next, whichever way it was made: Pick your plan (#814). */
export const NEW_ACCOUNT_DESTINATION = "/payment";

/** A save of the consent failed; the prompt stays (G42). */
export const SSO_CONSENT_SAVE_FAILED = "We couldn't save your acceptance. Try again.";

/** The parts of Clerk's resources the decision reads, in clerk-js's own field names. */
export interface SsoLandingInput {
  user: { id: string; createdAt: Date | null };
  /** `clerk.client.signUp` after the callback. */
  signUp: { status: string | null; createdUserId: string | null } | null | undefined;
  /** The Create your account box was ticked before the redirect. */
  ticked: boolean;
  /** Where an existing account goes (Log in's return_to). */
  to: string;
  now: number;
}

export type SsoLanding =
  | { kind: "record-tick"; destination: string }
  | { kind: "ask-consent"; destination: string }
  | { kind: "go"; destination: string };

/**
 * AN-25: what /auth/sso-complete does after Google or Apple.
 *
 * A new account is one this flow just created. Clerk gives a new account a session too,
 * both from Create your account and when Log in meets a first-time identity (it transfers
 * the sign-in to a sign-up), so "signed in" can never mean "existing" (mobile report 96).
 * The test is the completed sign-up that names this user, and an account only minutes old
 * is a fallback in case the client resource has moved on.
 */
export function ssoLanding({ user, signUp, ticked, to, now }: SsoLandingInput): SsoLanding {
  const createdHere = signUp?.status === "complete" && signUp.createdUserId === user.id;
  const created = user.createdAt ? user.createdAt.getTime() : 0;
  const isNewAccount = createdHere || now - created < NEW_ACCOUNT_WINDOW_MS;
  const destination = isNewAccount ? NEW_ACCOUNT_DESTINATION : to;

  if (ticked) return { kind: "record-tick", destination };
  if (isNewAccount) return { kind: "ask-consent", destination };
  return { kind: "go", destination };
}
